/**
 * Order by options for sites queries
 */
export const SITES_ORDER_BY = [
  'company_id',
  'company_name',
  'created_on',
  'end',
  'id',
  'is_active',
  'modified_on',
  'name',
  'start',
  'type',
] as const;
